module.exports = __webpack_public_path__ + "img/dfod-badge-inactive.7a22ce22.svg";